import React from "react";
import { useNavigate } from "react-router-dom";
import BoxIntegration from "../../../components/BoxIntegration";
import BoxIntegrationSkeleton from "../../../components/BoxIntegrationSkeleton";

import bannerBrindeleve from "../../../assets/images/banners/brindeleve.png";
import bannerClubeBrindeme from "../../../assets/images/banners/clube-brindeme.png";
import bannerSmrevenda from "../../../assets/images/banners/smrevenda.png";

const banners = [
    { src: bannerBrindeleve, alt: "Brindeleve" },
    { src: bannerClubeBrindeme, alt: "Clube Brindeme" },
    { src: bannerSmrevenda, alt: "SM Revenda" },
];

const SuppliersTab = ({ suppliers = [], loading = false }) => {
    const navigate = useNavigate();

    const handleDetailsClick = (supplierId) => {
        const supplier = suppliers.find(s => s.id === supplierId);
        navigate(`/integration/detail/${supplierId}`, { state: supplier });
    };

    return (
        <>
            {/* <div className="integration-banners">
                {banners.map((banner) => (
                    <div key={banner.alt} className="integration-banners__item">
                        <img src={banner.src} alt={banner.alt} />
                    </div>
                ))}
            </div> */}

            <p className="integration-tab-intro">
                Conecte-se aos seus fornecedores para importar produtos automaticamente.
            </p>

            <div className="suppliers-grid">
                {loading ? (
                    <>
                        {[...Array(6)].map((_, i) => (
                            <BoxIntegrationSkeleton key={i} />
                        ))}
                        <BoxIntegration isNewSupplier={true} />
                    </>
                ) : (
                    <>
                        {suppliers.map(supplier => (
                            <BoxIntegration
                                key={supplier.id}
                                logo={supplier.logo}
                                name={supplier.trade_name}
                                cnpj={supplier.cnpj}
                                razaoSocial={supplier.company_name}
                                productCount={supplier.productCount}
                                status={supplier.status}
                                onDetailsClick={() => handleDetailsClick(supplier.id)}
                            />
                        ))}
                        <BoxIntegration isNewSupplier={true} />
                    </>
                )}
            </div>
        </>
    );
};

export default SuppliersTab;
